import { render, staticRenderFns } from "./anniversaire.vue?vue&type=template&id=796d08c2"
import script from "./anniversaire.vue?vue&type=script&lang=js"
export * from "./anniversaire.vue?vue&type=script&lang=js"
import style0 from "./anniversaire.vue?vue&type=style&index=0&id=796d08c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports